import React from 'react';
import { Calendar, CreditCard, Users, Shield, Zap, Building } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: <Calendar size={40} />,
      title: "Smart Scheduling",
      description: "Automated appointment booking with real-time availability, reminders, and calendar sync across all devices."
    },
    {
      icon: <CreditCard size={40} />,
      title: "Integrated Billing",
      description: "Streamlined billing and payment processing with insurance claims, payment tracking, and financial reporting."
    },
    {
      icon: <Users size={40} />,
      title: "Patient Management",
      description: "Complete patient profiles with medical history, treatment plans, and secure communication tools."
    },
    {
      icon: <Shield size={40} />,
      title: "HIPAA Compliant",
      description: "Bank-level security with end-to-end encryption, audit trails, and compliance with healthcare regulations."
    },
    {
      icon: <Zap size={40} />,
      title: "Lightning Fast",
      description: "Optimized performance with cloud infrastructure ensuring 99.9% uptime and instant data access."
    },
    {
      icon: <Building size={40} />,
      title: "Multi-Location",
      description: "Manage multiple clinic locations from one dashboard with centralized reporting and analytics."
    }
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        <div className="section-header">
          <h2 className="section-title">Everything You Need <span className="section-title-gold">in One Platform</span></h2>
          <p className="section-description">Comprehensive medical portal solutions designed for modern healthcare practices</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
